import { useContext } from 'react';

import { FormReadOnlyContext } from '../context';

export function useFormReadOnly(): boolean {
  return useContext(FormReadOnlyContext).readOnly;
}
